import { createAction } from '@reduxjs/toolkit';
import type {
  BoundaryGroupId, BoundaryTerritoryGroupId,
} from '~/store/boundaries/boundaryIdentifier.type';
import type { BoundaryFilter } from '../boundary/mapSettingsToolsStateBoundary.state';

export const setDataLayersFilter = createAction(
  'SET_DATA_LAYERS_FILTER',
  (boundaryGroupId: BoundaryGroupId, filter: BoundaryFilter) => ({
    payload: {
      boundaryGroupId,
      filter,
    },
  })
);

export const activeDataLayersBTGIdPerBoundaryGroupChanged = createAction(
  'ACTIVE_DATA_LAYERS_BTG_ID_PER_BOUNDARY_GROUP_CHANGED',
  (boundaryGroupId: BoundaryGroupId, activeBTGId: BoundaryTerritoryGroupId) => ({
    payload: {
      boundaryGroupId,
      activeBTGId,
    },
  })
);
